import {SmartComponent} from "smart-component-js";

class SurveyThankYouComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.hash = window.location.hash?.replace('#', '');
        this.init();
    }

    init() {
        let result = this.element.querySelector(`div[data-id="${this.hash}"]`);
        if(!result) result = this.element.querySelector(`div[data-id]`);

        result.classList.remove('hidden');
    }
}

export default SurveyThankYouComponent;
